import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";

import MasKInput from "../../../Components/IconInputField";
import { TextLink } from "../styles";
import Colors from "../../../Constant/Colors";
import IconButton from "../../../Components/IconButton";
import { useDispatch, useSelector } from "react-redux";
import images from "../../../Constant/images";
import {
  apiSignupRequest,
  editProfileRequest,
} from "../../../Redux/actions/auth";
import dayjs from "dayjs";
import CalendarComponent from "../../../Components/Calendar";
import SmartImage from "../../../Components/SmartImage";
import {
  BoldHeadingPri,
  HorizontalAlign,
  VerticalAlign,
} from "../../../Components/CustomStyles";
import { stripeOnboardRequest } from "../../../Redux/actions/home";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import ModalComponent from "../../../Components/Modal";
import axios from "axios";


const SignupForm = ({
  auth,
  handleAuthPage,
  formData,
  handleCalendar,
  openCalendar,
  closeModal,
  isEditPage,
  profile,
  loading,
}) => {
  const dispatch = useDispatch();
  const { signupErrors, isInstructor, isLoading, token } = useSelector(
    (state) => state.auth
  );
  const [onUploadProgress, setUploadProgress] = useState({
    count: 0,
    isStart: false,
  });
  const [profileImage, setProfileImage] = useState(null);
  const [showPass, setShowPass] = useState({ pass1: false, pass2: false });
  const [openModal, setOpenModal] = useState(false);
  const initialValues = {
    first_name: "",
    username: "",
    email: "",
    phone_number: "",
    password: "",
    password2: "",
    birth_date: "",
    zip_code: "",
  };

  const validationSchema = yup.object().shape({
    first_name: yup.string().required("Please enter full name"),
    username: yup.string().required("Please enter username"),
    email: yup
      .string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Please enter email address"),

    birth_date: yup.string().required("Please enter date of birth"),
    zip_code: yup.number().required("Please enter zip code"),
    password: yup
      .string()
      .test(
        "password-validation",
        "Password should be at least 8 characters long, contain at least one uppercase letter and one special character",
        function (value) {
          if (isEditPage) {
            // If in edit page, skip validation
            return true;
          }

          // Apply validation rules if not in edit page
          return (
            value != null &&
            value.length >= 8 &&
            /[A-Z]/.test(value) &&
            /[!@#$%^&*(),.?":{}|<>]/.test(value)
          );
        }
      ),

    password2: yup
      .string()
      .test("password2-validation", "Passwords must match", function (value) {
        if (isEditPage) {
          // If in edit page, skip validation
          return true;
        }

        // Apply validation rules if not in edit page
        return value === this.parent.password;
      }),
  });

  const onSubmit = (values) => {

    if (isEditPage) {
      delete values["password"];
      delete values["password2"];
      dispatch(editProfileRequest(values));
    } else {
      let data = values;
      data["role"] = formData?.role;
      data["phone_number"] = data?.phone_number.split(" ").join("");
      dispatch(apiSignupRequest(values));
    }
  };
  const formik = useFormik({ initialValues, validationSchema, onSubmit });

  const handlePassIcon = (type) => {
    if (type === 1) {
      setShowPass((prev) => ({ ...prev, pass1: !prev.pass1 }));
    } else {
      setShowPass((prev) => ({ ...prev, pass2: !prev.pass2 }));
    }
  };

  const getError = (field) => {
    if (formik.touched[field] && formik.errors[field]) {
      if (Array.isArray(formik.errors[field])) {
        return formik.errors[field][0]; // return the first error in the array
      }
      return formik.errors[field]; // return the error string
    }
    return null;
  };

  useEffect(() => {
    if (signupErrors && Object.keys(signupErrors).length) {
      formik.setErrors(signupErrors);
    }
  }, [signupErrors]);

  const styles = {
    main: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      alignSelf: "center",
      flexDirection: "column",
    },
    container: {
      width: "90%",
      minWidth: 300,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },

    agreementTxt: {
      fontSize: 12,
      color: Colors.lightTxt,
      textAlign: "center",
    },
    mainStyle: {
      width: "49%",
      minWidth: 260,
    },
    imgView: {
      border: `3px solid ${Colors.primary}`,
      height: 65,
      width: 65,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      overflow: "hidden",
      cursor: "pointer",
    },
    img: { height: 60, width: 60, borderRadius: 100 },
  };

  const openImgModal = () => setOpenModal(true);
  const closeImgModal = () => setOpenModal(false);

  const handleImageChange = async (img) => {
    const file = img;
    if (!file) return;
    const imageUrl = await uploadFileToS3(file);
    setProfileImage(imageUrl);
    formik.setFieldValue("profile_pic", imageUrl);
    closeImgModal();
  };

  const uploadFileToS3 = async (file) => {
    if (!file) return;

    let fileName = file.name;
    const fileType = file.type;
    fileName = fileName.replace(/ /g, "_");

    // Step 1: Request presigned URL from backend
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/course/content/s3/url/`,
      {
        file_name: fileName,
        file_type: fileType,
        profile: true,
      },
      {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      }
    );

    const presignedUrl = data.url;
    console.log("presignedUrl", presignedUrl);

    // Step 2: Upload the file directly to S3 using the presigned URL
    await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": fileType,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (percentCompleted === 100) {
          setUploadProgress({ isStart: false, count: percentCompleted });
        } else {
          setUploadProgress({ isStart: true, count: percentCompleted });
        }
      },
    });

    // Step 3: After successful upload, save the file URL in the backend (Optional)
    const fileUrl = `https://e-learning-s3.s3.amazonaws.com/media/profile/${fileName}`;

    return fileUrl;
  };

  const handleAddCard = () => dispatch(stripeOnboardRequest("editProfile"));

  useEffect(() => {
    if (profile?.id) {
      formik.setFieldValue("first_name", profile?.first_name);
      formik.setFieldValue("username", profile?.username);
      formik.setFieldValue("email", profile?.email);
      formik.setFieldValue("phone_number", profile?.phone_number);
      formik.setFieldValue("birth_date", profile?.birth_date);
      formik.setFieldValue("zip_code", profile?.zip_code);
      if (profile?.profile_pic) {
        setProfileImage(profile?.profile_pic);
      }
    }
  }, [profile?.id]);
  const fileTypes = ["JPG", "PNG"];

  return (
    <div style={styles.main}>
      <VerticalAlign>
        <div style={styles.imgView} onClick={openImgModal}>
          <SmartImage src={profileImage ?? images.profile} style={styles.img} />
        </div>
      </VerticalAlign>
      <div style={styles.container}>
        <MasKInput
          type={"text"}
          name="first_name"
          icon={images.user}
          placeholder="Full Name"
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("first_name")}
          value={formik.values.first_name}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          maxLength={20}
        />
        <MasKInput
          type={"text"}
          name="username"
          placeholder="Username"
          icon={images.username}
          onBlur={formik.handleBlur}
          mainStyle={styles.mainStyle}
          error={getError("username")}
          value={formik.values.username}
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          maxLength={20}
          readOnly={isEditPage}
        />
        <MasKInput
          name="email"
          placeholder="Email"
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          value={formik.values.email}
          mainStyle={styles.mainStyle}
          icon={images.mail}
          onBlur={formik.handleBlur}
          type={"email"}
          error={getError("email")}
          readOnly={isEditPage}
        />
        <MasKInput
          name="phone_number"
          placeholder="Phone Number (e.g. 123 456 7890)"
          mask="999 999 999 999"
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          value={formik.values.phone_number}
          onBlur={formik.handleBlur}
          error={getError("phone_number")}
          mainStyle={styles.mainStyle}
          icon={images.call}
          type={"text"}
          maxLength={15}
        />
        {!isEditPage && (
          <>
            <MasKInput
              name="password"
              placeholder="Password"
              onChangeText={(name, e) => formik.setFieldValue(name, e)}
              value={formik.values.password}
              mainStyle={styles.mainStyle}
              error={getError("password")}
              onBlur={formik.handleBlur}
              type={showPass.pass1 ? "text" : "password"}
              icon={images.lock}
              rightIcon={images.eye_off}
              rightIconPress={() => handlePassIcon(1)}
            />
            <MasKInput
              name="password2"
              placeholder="Confirm Password"
              onChangeText={(name, e) => formik.setFieldValue(name, e)}
              value={formik.values.password2}
              mainStyle={styles.mainStyle}
              error={getError("password2")}
              type={showPass.pass2 ? "text" : "password"}
              onBlur={formik.handleBlur}
              icon={images.lock}
              rightIcon={images.eye_off}
              rightIconPress={() => handlePassIcon(2)}
            />
          </>
        )}
        <MasKInput
          name="birth_date"
          placeholder="Birth Date"
          mainStyle={styles.mainStyle}
          value={
            formik?.values?.birth_date
              ? dayjs(formik?.values?.birth_date).format("DD-MMM-YYYY")
              : ""
          }
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          onBlur={formik.handleBlur}
          icon={images.calendar}
          readOnly
          rightIcon={images.calendar}
          rightIconPress={handleCalendar}
          error={getError("birth_date")}
        />
        <MasKInput
          name="zip_code"
          mainStyle={styles.mainStyle}
          placeholder="Zip Code"
          onChangeText={(name, e) => formik.setFieldValue(name, e)}
          value={formik.values.zip_code}
          onBlur={formik.handleBlur}
          icon={images.lock}
          mask={"99999999"}
          error={getError("zip_code")}
        />
      </div>
      {isEditPage && isInstructor && (
        <HorizontalAlign>
          <SmartImage src={images.card} style={{ height: 30, width: 30 }} />
          <BoldHeadingPri style={{ width: 290, textAlign: "center" }}>
            Bank Details
          </BoldHeadingPri>
          <IconButton
            text={profile?.stripe_connected ? "Added" : "Add"}
            style={{
              paddingLeft: 5,
              paddingRight: 5,
              marginLeft: 10,
              backgroundColor: profile?.stripe_connected
                ? Colors.whiteThemeColor
                : Colors.primary,
              border: `1px solid ${Colors.primary}`,
            }}
            textStyle={{
              color: profile?.stripe_connected
                ? Colors.primary
                : Colors.whiteThemeColor,
            }}
            disabled={profile?.stripe_connected}
            onClick={handleAddCard}
          />
        </HorizontalAlign>
      )}
      {!isEditPage && (
        <div style={{ width: "70%", minWidth: 220 }}>
          <p className="text-center mt-4" style={styles.agreementTxt}>
            By creating an account means you agree to the{" "}
            <TextLink>Terms & Conditions</TextLink> and our{" "}
            <TextLink>Privacy Policy</TextLink>
          </p>
        </div>
      )}
      <div style={{ width: "49%", minWidth: 220 }}>
        <IconButton
          text={isEditPage ? "Update Profile" : "Sign Up"}
          onClick={formik.handleSubmit}
          loading={isEditPage ? isLoading : auth?.isLoading}
          disabled={isEditPage ? isLoading : auth?.isLoading}
        />

        {!isEditPage && (
          <p
            className="form-text text-center mt-4"
            style={{ fontSize: 12, color: Colors.primary, textAlign: "center" }}
          >
            Already have an account?{"   "}
            <TextLink onClick={() => handleAuthPage("isLogin", true)}>
              Sign In
            </TextLink>
          </p>
        )}
      </div>
      {openCalendar && (
        <CalendarComponent
          openCalendar={openCalendar}
          closeModal={closeModal}
          // formUpdate={formUpdate}
          date={formik?.values.birth_date}
          onChange={(e) => formik.setFieldValue("birth_date", e)}
          maxDate={new Date()}
        />
      )}
      {openModal && (
        <ModalComponent
          heading={"Upload Profie Picture"}
          openModal={openModal}
          closeModal={closeImgModal}
          yesBtn={onUploadProgress?.isStart ? true : false}
          disabledYesBtn={true}
          yesBtnTxt={
            onUploadProgress?.isStart ? `${onUploadProgress?.count}%` : ""
          }
        >
          <FileUploader
            handleChange={handleImageChange}
            name="file"
            types={fileTypes}
            maxSize={10}
            onTypeError={(e) => toast.error(e)}
            onSizeError={(e) => toast.error(e)}
          />
        </ModalComponent>
      )}
    </div>
  );
};
export default SignupForm;
